var exports = {
  "nf": "x234b8571--b00533--link",
  "ib": "x234b8571--b00533--link--m",
  "sE": "x234b8571--b00533--link--fontweight400",
  "dR": "x234b8571--b00533--link--fontweight700",
};

module.exports = exports;
